import script from "./Start.vue?vue&type=script&setup=true&lang=js"
export * from "./Start.vue?vue&type=script&setup=true&lang=js"

import "./Start.vue?vue&type=style&index=0&id=7b72d6ea&scoped=true&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b72d6ea"]])

export default __exports__